import { base44 } from '@/api/base44Client';

// Shared, cached EN -> ES translation of site copy. Results are stored server-side
// once (ContentTranslation) and in localStorage, so repeat visits are instant.
const KEY = 'jh_tr_es_v1';
const cache = new Map(Object.entries(JSON.parse(localStorage.getItem(KEY) || '{}')));
const pending = new Set();
const inflight = new Set();
const listeners = new Set();
let timer = null;

const persist = () => {
  try { localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(cache))); } catch { /* quota */ }
};

const chunks = (list) => {
  const out = [];
  let cur = [];
  let size = 0;
  for (const t of list) {
    if (cur.length && (size + t.length > 12000 || cur.length >= 30)) { out.push(cur); cur = []; size = 0; }
    cur.push(t); size += t.length;
  }
  if (cur.length) out.push(cur);
  return out;
};

const flush = () => {
  timer = null;
  const list = [...pending].filter((t) => t.length <= 20000);
  pending.clear();
  list.forEach((t) => inflight.add(t));
  chunks(list).forEach(async (batch) => {
    const res = await base44.functions.invoke('translateTexts', { texts: batch, lang: 'es' }).catch(() => null);
    const out = res?.data?.translations;
    batch.forEach((t, i) => { inflight.delete(t); if (out?.[i]) cache.set(t, out[i]); });
    persist();
    listeners.forEach((fn) => fn());
  });
};

export function autoTranslate(text) {
  if (cache.has(text)) return cache.get(text);
  if (!inflight.has(text) && !pending.has(text)) {
    pending.add(text);
    if (!timer) timer = setTimeout(flush, 120);
  }
  return text;
}

export function onTranslations(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}